import React from "react";
import PropTypes from "prop-types";
import { Content, useTranslator } from "@sia/style-guide";
import Page from "../Page";

const NotFoundPage = (props) => {
  const translate = useTranslator();
  const message = props.message ? props.message : "routing.page.not-found.text";
  return (
    <Page title={""} className={""}>
      <Content>
        <div className="not-found-page">
          <h1>{translate("routing.page.not-found.title")}</h1>
          <p>{translate(message)}</p>
        </div>
      </Content>
    </Page>
  );
};
NotFoundPage.propTypes = {
  message: PropTypes.string,
};
export default NotFoundPage;
